import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/header/navbar';
import Home from './pages/home/home';
import AboutUs from './pages/about-us/aboutUs';
import ContactUs from './pages/contact-us/contactUs';
import Footer from './components/footer/footer';
import Blog from './pages/blog/blog';
import MobileDevelopment from './pages/services/mobile-development/mobile-development';
import JobHighlightsOverlay from "./pages/career/JobHighlightsOverlay";
import WebDevelopment from './pages/services/web-development/web-development';
import QualityAssurance from './pages/services/quality-assurance/quality-assurance';
import GraphicDesigning from './pages/services/graphic-desiging/graphic-desiging';
import SocialMediaMarketing from './pages/services/social-media-marketing/social-media-marketing';
import BuisnessBranding from './pages/services/buisness-branding/buisness-branding';
import CustomWebSolution from './pages/services/custom-web-solution/custom-web-solution';
import ScrollToTop from './ScrollToTop';
import Staffing from './pages/services/staffing/Staffing';
import BlogQaImportance from './pages/blog/blogs-data/blog-qa-importance';
import BlogWebDevelopment from './pages/blog/blogs-data/blog-web-development';
import BlogDevelopmentLang from './pages/blog/blogs-data/blog-development-lang';
import BlogNativeHybrid from './pages/blog/blogs-data/blog-native-hybrid';
import BlogRedux from './pages/blog/blogs-data/blog-redux';
import BlogSoftwareTestingImportance from './pages/blog/blogs-data/blog-software-testing-imp';
import BlogQaAnalyst from './pages/blog/blogs-data/blog-qa-analyst';
import BlogOutsourcingQa from './pages/blog/blogs-data/blog-outsourcing-qa';
import './App.css';
import NotFoundPage from './components/page-not-found/PageNotFound';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="*" element={<NotFoundPage />} />
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/mobile-development" element={<MobileDevelopment />} />
        <Route path="/website-development" element={<WebDevelopment />} />
        <Route path="/quality-assurance" element={<QualityAssurance />} />
        <Route path="/staffing-solutions" element={<Staffing />} />
        <Route path="/graphic-designing" element={<GraphicDesigning />} />
        <Route
          path="/social-media-marketing"
          element={<SocialMediaMarketing />}
        />
        <Route path="/buisness-branding" element={<BuisnessBranding />} />
        <Route path="/custom-web-solution" element={<CustomWebSolution />} />
        <Route path="/career" element={<JobHighlightsOverlay />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/qa-importance" element={<BlogQaImportance />} />
        <Route path="/blog/web-development" element={<BlogWebDevelopment />} />
        <Route
          path="/blog/development-language"
          element={<BlogDevelopmentLang />}
        />
        <Route path="/blog/native-hybrid" element={<BlogNativeHybrid />} />
        <Route
          path="/blog/software-testing-importance"
          element={<BlogSoftwareTestingImportance />}
        />
        <Route path="/blog/qa-analyst" element={<BlogQaAnalyst />} />
        <Route path="/blog/redux" element={<BlogRedux />} />
        <Route path="/blog/outsourcing-qa" element={<BlogOutsourcingQa />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
